import React from "react";
import LegalLayout from "../components/legal/LegalLayout";

const ChildSafety = () => (
  <LegalLayout title="Child Safety Standards" testId="child-safety-content">
    <h1>Child Safety Standards – Thryvin'</h1>
    <p className="last-updated">Last updated: 15 October 2026</p>

    <p className="intro">
      Thryvin' is a fitness and nutrition app for adults. The app, and its Community feature in particular, is only for
      people aged 18 and over.
    </p>

    <section>
      <h2>Zero tolerance for child sexual abuse and exploitation</h2>
      <p>
        We do not allow child sexual abuse material (CSAM) or any content or behaviour that sexually exploits or
        endangers children (CSAE) anywhere in Thryvin'. This includes sexualised images or text involving anyone under
        18, grooming, and any attempt to contact or exploit a child.
      </p>
    </section>

    <section>
      <h2>How we keep children out</h2>
      <ul>
        <li>Everyone gives their date of birth when they sign up, and the app is 18+.</li>
        <li>Joining Community needs a second 18+ confirmation, which our server checks against the date of birth.</li>
        <li>Community has no direct messages, and Live reaction and profile photos are only shown to friends.</li>
        <li>Every Community photo and post is automatically checked for safety before anyone else sees it.</li>
      </ul>
    </section>

    <section>
      <h2>How to report</h2>
      <ul>
        <li>
          <strong>In the app:</strong> tap ⋯ on any post, comment, photo or profile, then Report. Choose "Seems under
          18" or "Sexual content". Either one hides the content from everyone straight away while we review it.
        </li>
        <li>
          <strong>By email:</strong>{" "}
          <a href="mailto:support@thryvin.app" className="inline-link">
            support@thryvin.app
          </a>
          . Please describe what you saw and where. Don't attach or forward the material itself.
        </li>
      </ul>
      <p>We aim to review these reports within 24 hours.</p>
    </section>

    <section>
      <h2>What we do</h2>
      <p>When we find or are told about suspected child sexual abuse material, we:</p>
      <ul>
        <li>close the account involved,</li>
        <li>keep the evidence securely and privately (we don't delete or share it),</li>
        <li>
          report it to the UK National Crime Agency (NCA) and the Internet Watch Foundation (IWF), and to other
          authorities where the law requires.
        </li>
      </ul>
      <p className="note">
        If you think a child is in immediate danger, call 999 in the UK or your local emergency number.
      </p>
    </section>

    <section>
      <h2>Compliance</h2>
      <p>Thryvin' complies with the child safety laws that apply to it, including the UK Online Safety Act 2023.</p>
    </section>

    <section>
      <h2>Child safety contact</h2>
      <p>
        Jake West, Thryvin' ·{" "}
        <a href="mailto:support@thryvin.app" className="inline-link">
          support@thryvin.app
        </a>
      </p>
    </section>
  </LegalLayout>
);

export default ChildSafety;
